module.exports = __webpack_public_path__ + "static/media/loading.4cacdcb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.svg
// module id = 628
// module chunks = 21